import script from "./CreateSpv.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateSpv.vue?vue&type=script&setup=true&lang=js"

import "./CreateSpv.vue?vue&type=style&index=0&id=4cf3aa07&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf3aa07"]])

export default __exports__